<footer
    fxLayout="row"
    fxLayout.lt-md="column"
    fxLayoutAlign="space-between center"
>
    <div fxLayout="row" fxLayoutAlign="start center">
        <div class="powered-by">
            <p>
                Powered by
                <img
                    src="../../../assets/images/enliveo-trademark.svg"
                    alt="enliveo logo"
                />
                enliveo
            </p>
        </div>
    </div>
    <div
        fxLayoutGap="10px"
        fxLayout="row"
        class="links"
        fxLayoutAlign="end center"
    >
        <p class="btn-reset-style copyright tm">
            {{ '© enliveo' | transloco }} {{ year }}
        </p>
        <button
            class="btn-reset-style"
            (click)="navigateToPrivacy()"
            aria-label="Read our privacy policy"
        >
            {{ 'Privacy' | transloco }}
        </button>
        <button
            class="btn-reset-style"
            (click)="navigateToTOS()"
            aria-label="Read our terms of services"
        >
            {{ 'TOS' | transloco }}
        </button>
        <button
            class="btn-reset-style"
            (click)="navigateToCookiesPage()"
            aria-label="Read our cookie policy"
        >
            {{ 'Cookie Policy' | transloco }}
        </button>
    </div>
</footer>
